import { Theme, css } from '@emotion/react';

export const checkbox = (theme: Theme) => css`
  margin: 0 ${theme.spacing(1)}px;
`;

export const menuItem = () => css`
  &:hover {
    cursor: pointer;
  }
`;

export const chip = css`
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const tagContainer = (theme: Theme) => css`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing(1)}px;
`;

export const optionLabel = css`
  text-wrap: wrap;
`;
